export const ChartCartesianConstants = {
  yAxisTickCount: 5,
}
